<template>
 <div class="fluid">
    <div id="mainLista">

        <b-row>
            <b-col sm="12">
                <div id="barratitulo">
                    <br/><br/>
                    <b-row>
                        <b-col sm="11">
                            <h1>REQUISIÇÃO DE PEQUENO VALOR</h1>                           
                        </b-col>
                        <b-col sm="1">
                            <b-button variant="success" class="mx-1 botao" @click="$emit('voltar')">Voltar</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
            <p id="texto">
                Informações sobre o andamento do processo das requisições ou obrigações de pequeno valor (RPV/OPV).
                <br/><br/>
                Caso sua consulta retorne a situação "Pagamento Realizado (Lote)", isso indica que o processo pertence a um lote e que o pagamento no processo principal foi devidamente realizado. Para maiores informações, consultar as tramitações do processo judicial principal (CNJ) constante do comprovante.
                <br/>
                <br/>
                <b>Em caso de dúvidas, entrar em contato pelo e-mail: rpv@sefa.pr.gov.br</b>
                <br/>
                <br/>
            </p>
            </b-col>
        </b-row>

            <b-input v-show="false" plaintext v-model="filtros.nrProcessoFmt" type="text" v-mask="'#######-##.####.#.##.####'" autocomplete="off"></b-input>                
            <span v-if="filtros.nrProcesso"><strong>N° dos Autos: </strong>{{filtros.nrProcessoFmt}}&nbsp;&nbsp;</span>            
            <span v-if="filtros.nome"><strong>Nome Beneficiário: </strong>{{filtros.nome}}&nbsp;&nbsp;</span>
            <span v-if="filtros.documento"><strong>{{filtros.documento.length == 11 ? 'CPF ' : 'CNPJ '}}do Beneficiário: </strong>{{filtros.documentoFmt}}&nbsp;&nbsp;</span>
            <span v-if="filtros.dataIniFormatada"><strong>Período de Pagamento: </strong>{{filtros.dataIniFormatada}}&nbsp;Até&nbsp;{{filtros.dataFimFormatada || filtros.dataIniFormatada}} </span>
        <br/>
        <br/>

        <div v-if="lista.length">
        <b-table
            id="tabela"
            show-empty
            stacked="sm"
            hover="hover"
            striped="striped"
            :items="lista"
            :fields="colunas"            
            :current-page="currentPage"
            :per-page="0"
            :busy="pesquisando"
            class="tableClass"
            tbody-tr-class="rowClass"
            >
                <div slot="empty" colspan="2" align="center"></div>
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Pesquisando ...</strong>
                </div>

                <template #head(nrProcessoFmt)="data">
                    <div v-b-tooltip.hover title="Número do Processo Judicial"> {{data.label}}</div>
                </template>
                <template #head(nmBeneficiario)="data">
                    <div v-b-tooltip.hover title="Nome do beneficiário do crédito"> {{data.label}}</div>
                </template>
                <template #head(vlrBrutoFmt)="data">
                    <div v-b-tooltip.hover title="Valor Total do Pagamento"> {{data.label}}</div>
                </template>
                <template #head(vlrIRFmt)="data">
                    <div v-b-tooltip.hover title="Valor do Imposto de Renda retido na fonte"> {{data.label}}</div>
                </template>
                <template #head(vlrPrevidenciaFmt)="data">
                    <div v-b-tooltip.hover title="Valor da contribuição Previdenciária retida na fonte"> {{data.label}}</div>
                </template>
                <template #head(vlrLiquidoFmt)="data">
                    <div v-b-tooltip.hover title="Valor creditado, descontadas as retenções"> {{data.label}}</div>
                </template>
                <template #head(descSituacaoRPV)="data">
                    <div v-b-tooltip.hover title="Status do andamento da RPV"> {{data.label}}</div>
                </template>
                <template #head(dtLancBancarioLogFmt)="data">
                    <div v-b-tooltip.hover title="Data do pagamento em Conta Bancária"> {{data.label}}</div>
                </template>
                <template #head(identificacaoOuPagamento)="data">
                    <div v-b-tooltip.hover title="Autenticação Bancária do Depósito efetuado"> {{data.label}}</div>
                </template>
                <template #head(guia)="data">
                    <div v-b-tooltip.hover title="Número de Identificação do Depósito judicial, para maiores informações consulte processo"> {{data.label}}</div>
                </template>
                <template #head(comprovante)="data">
                    <div v-b-tooltip.hover title="Apresenta documento com os dados de pagamento"> {{data.label}}</div>
                </template>

                <template v-slot:cell(dtLancBancarioLogFmt)="data">
                    <span v-if="data.item.idSituacaoRPV == 46 || data.item.idSituacaoRPV == 47 || data.item.idSituacaoRPV == 48">{{data.item.dtLancBancarioLogFmt }}</span>
                </template>

                <template v-slot:cell(identificacaoOuPagamento)="data">
                    <span v-if="data.item.idSituacaoRPV == 46 || data.item.idSituacaoRPV == 47 || data.item.idSituacaoRPV == 48">{{data.item.idDJCaixaOuHashPgtoFmt }}</span>
                </template>

                <template v-slot:cell(guia)="data">
                    <span v-if="data.item.linkAcessoGuiaDepJud">
                        Copie a identificação e <a target="_blank" :href="data.item.linkAcessoGuiaDepJud">clique aqui</a>
                    </span>
                </template>

                <template v-slot:cell(comprovante)="data">
                <span v-if="data.item.temComprovantePagamento">
                    <b-link title="Comprovante de pagamento" class="btn btn-outline-success ml-1" @click="emitirComprovante(data.item.idRPV)"><i class="fas fa-file-invoice-dollar"></i></b-link>
                </span>
                </template>
        </b-table>
        <b-row style="font-style: italic">
            <b-col>Fonte: RPV <br/><span v-if="dataAtualFormatada"> Emissão: {{dataAtualFormatada}}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>* Informações sobre retenções devem ser consultadas no processo judicial</p>
            </b-col>
        </b-row>

        <b-row>
        <b-col sm="12">
            <b-card-footer style="background-color: #ffffff">
            <div class="d-flex justify-content-left">
                <b-button href="#" variant="success" class="mx-1 botao" @click="gerarPDF(filtros)">
                    SALVAR EM PDF
                </b-button>
                <b-button href="#" variant="success" class="ml-1 botao" @click="gerarCSV(filtros)">
                    VISUALIZAR EM PLANILHA
                </b-button>
            </div>
            </b-card-footer>      
        </b-col>
        </b-row>
        </div>        
    </div>
    <a v-show="false" ref="arquivo"></a>    
 </div>  
</template>

<script>
import servicoRPV from '@/api/rpv'
import servicoData from '@/api/data'
import lpad from '@/lib/lpad'
import debug from '@/util/debug'

const fnm = 'transp/_ListaConsulta.vue'

export default {
    props: {
        filtros: {},
        lista: []
    },
    data() {
        return {
            dataAtualFormatada: '',
            colunas: [
                {
                    id: "nrProcessoFmt",
                    key: 'nrProcessoFmt', 
                    label: 'Nº dos Autos',
                    thClass: 'text-left',
                    tdClass: 'width4 text-center',
                },
                { 
                    key: 'nmBeneficiario', 
                    label: 'Beneficiário / Custas',
                    thClass: 'text-left',
                    tdClass: 'width8 text-left'
                },
                {
                    key: 'vlrBrutoFmt', 
                    label: 'Valor Bruto',
                    thClass: 'text-left',
                    tdClass: 'width4 text-right'
                },
                {
                    key: 'vlrIRFmt',
                    label: 'Imposto de Renda (IR)',
                    thClass: 'text-left',
                    tdClass: 'width4 text-right'
                },
                {
                    key: 'vlrPrevidenciaFmt', 
                    label: 'Previdência',
                    thClass: 'text-left',
                    tdClass: 'width4 text-right'
                },
                {
                    key: 'vlrLiquidoFmt', 
                    label: 'Valor Líquido',
                    thClass: 'text-left',
                    tdClass: 'width4 text-right'
                },
                {
                    key: 'descSituacaoRPV', 
                    label: 'Situação',
                    thClass: 'text-left',
                    tdClass: 'width4 text-center'
                },
                {
                    key: 'dtLancBancarioLogFmt', 
                    label: 'Data Pagamento',
                    thClass: 'text-left',
                    tdClass: 'width4 text-center'
                },
                { 
                    key: 'identificacaoOuPagamento', 
                    label: 'Identificação ou  Nº Pagamento',
                    thClass: 'text-left',
                    tdClass: 'width4 text-left'
                },
                { 
                    key: 'guia', 
                    label: 'Acesso a Guia (Depósito Judicial)',
                    thClass: 'text-left',
                    tdClass: 'width4 text-left'
                },
                { 
                    key: 'comprovante', 
                    label: 'Comprovante de Pagamento',
                    thClass: 'text-left',
                    tdClass: 'width1 text-center'
                },
            ],

        }
    },
    created() {
        debug(null, 'created', fnm)
        servicoData.dataAtual().then((res)=> {            
            this.dataAtualFormatada = res.data.replace(' ', ' às ')
        })
    },
    methods: {
        podeEmitirComprovante(situacaoRpv) {
            debug(null, 'podeEmitirComprovante', fnm)
            return situacaoRpv == 46 || situacaoRpv == 47 || situacaoRpv == 48
        },
        emitirComprovante(idRpv) {
           let mtd = 'emitirComprovante'
      	   debug(null, mtd, fnm)
           servicoRPV.emitirCompPagtoPortalTransp(idRpv)
            .then((res) => {
                debug('Emitir Comprovante OK', mtd, fnm)
                const file = new Blob([res.data], { type: `application/pdf` })
                const fileURL = URL.createObjectURL(file)
                
                let nomeDoArquivo = res.headers['content-disposition'].split('=')[1]

                this.$refs.arquivo.href = fileURL
                this.$refs.arquivo.download = nomeDoArquivo
                this.$refs.arquivo.click()
            })
            .catch(res => {
                debug(`Emitir Comprovante ERRO [${JSON.stringify(res)}]`, mtd, fnm)
                this.mensagemDeErroGenerica(res)
            })

        },
        gerarPDF(filtros) {
           let mtd = 'gerarPDF'
           debug(null, mtd, fnm)
           servicoRPV.baixarArqPdfConsRpvPortal(filtros)
            .then((res) => {
                debug('Baixar PDF OK', mtd, fnm)
                const file = new Blob([res.data], { type: `application/pdf` })
                const fileURL = URL.createObjectURL(file)
                
                let nomeDoArquivo = res.headers['content-disposition'].split('=')[1]

                this.$refs.arquivo.href = fileURL
                this.$refs.arquivo.download = nomeDoArquivo
                this.$refs.arquivo.click()
            })
            .catch(res => {
                debug(`Baixar PDF ERRO [${JSON.stringify(res)}]`, mtd, fnm)
                this.mensagemDeErroGenerica(res)
            })
        },
        gerarCSV(filtros) {
          let mtd = 'gerarCSV'
          debug(null, mtd, fnm)
          servicoRPV.baixarArqCsvConsRpvPortal(filtros)
            .then((res) => {
                debug('Baixar CSV OK', mtd, fnm)
                const file = new Blob([res.data], { type: `application/octet-stream` })
                const fileURL = URL.createObjectURL(file)
                
                let arrayHeader = res.headers['content-disposition'].split(';')
                let nomeDoArquivo = arrayHeader[1].split("\"")[1]

                this.$refs.arquivo.href = fileURL
                this.$refs.arquivo.download = nomeDoArquivo
                this.$refs.arquivo.click()
            })
            .catch(res => {
                debug(`Baixar CSV ERRO [${JSON.stringify(res)}]`, mtd, fnm)
                this.mensagemDeErroGenerica(res)
            })
        }        
    }
}
</script>

<style>
#main {

}
#barratitulo {
    padding: 10px 10px 10px 10px;
    min-height: 119px;
    border-width: 0px;
    left: 0px;
    top: 0px;
    background: inherit;
    background-color: inherit;
    background-color: rgba(0, 128, 128, 1);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-justify: inter-word;
}
#texto, .formulario {
    padding: 10px 10px 10px 10px;
}
h1 {
    font-family:'Arial Negrito', 'Arial Normal', 'Arial';
    font-weight:700;
}
.botao {
    font-family: 'Arial Normal', 'Arial';
    font-weight: bold;
    font-style: normal;
    font-size: 16px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
}
label {
 white-space: nowrap;
}
.table td {    
    border: 1px solid #a0a0a0;
}
.table thead, .table th {    
    background-color: rgb(129, 211, 248);
    border: 1px solid #a0a0a0;
}
.table th.text-left {
    vertical-align: middle;
}
.table th div {    
    vertical-align: middle;
    text-align: center;
}
body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
}

html {
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
}

</style>
